import { DefaultButton, Modal, PrimaryButton } from '@fluentui/react';
import React from 'react';

function ConfirmModal({ isConfirmOpen, closeConfirmModal, handleSubmit, totalToUpdate }) {
    return (
        <Modal isOpen={isConfirmOpen} onDismiss={closeConfirmModal}>
            <div style={{ padding: '30px', textAlign: 'center' }}>
                {totalToUpdate === 0 ? (
                    <h4>Are you ready to submit values from all tabs for this cobrand?</h4>
                ) : (
                    <>
                        <h4>
                            Are you sure you want to submit these values from all tabs to the
                            <strong
                                style={{
                                    backgroundColor: '#fed9cc',
                                    padding: '2px',
                                    paddingLeft: '4px',
                                    paddingRight: '4px',
                                    marginLeft: '4px',
                                    marginRight: '4px',
                                    borderRadius: '2px',
                                }}
                            >
                                {totalToUpdate}
                            </strong>
                            selected CoBrands?
                        </h4>
                        <p>See full list at bottom of "Select Cobrand" tab</p>
                    </>
                )}
                <PrimaryButton
                    text="Yes, Submit"
                    onClick={handleSubmit}
                    style={{ marginRight: '20px', marginTop: '20px' }}
                />
                <DefaultButton text="No, Cancel" onClick={closeConfirmModal} />
            </div>
        </Modal>
    );
}

export default ConfirmModal;
